import { useLocation } from "react-router-dom";

/**
 * SMT-1354: the ZM and VAT `SubNavigation`s set this router state when a tab
 * switch navigates to a sibling tab (ELSTER, Submissions, DFV, …). The list
 * containers on those views read it via `useIsWithinTabs` to tell "returning
 * from a sibling tab" apart from "arriving from outside" (e.g. a `?email=`
 * link from the Alle-Mandanten view or the customer drawer) — only the latter
 * should seed the list filter from the `email` selection param.
 *
 * Router state does not survive a `use-query-params` write: those replace the
 * location without carrying `state` along. So a reload right after an expand
 * (which sets `email` via a query-param write, not a tab navigation) has no
 * `withinTabs` state and counts as an arrival, same as any fresh link.
 */
export const WITHIN_TABS_STATE = { withinTabs: true } as const;

type WithinTabsLocationState = { withinTabs?: boolean } | null;

export const useIsWithinTabs = (): boolean => {
  const { state } = useLocation();
  return Boolean((state as WithinTabsLocationState)?.withinTabs);
};
